var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablerReload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:reload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2894 8.69448C13.1635 9.65445 12.7786 10.562 12.1761 11.3199C11.5736 12.0778 10.7762 12.6574 9.86933 12.9965C8.96247 13.3356 7.98041 13.4215 7.02846 13.2449C6.07652 13.0683 5.1906 12.6359 4.46573 11.994C3.74085 11.3522 3.20437 10.5251 2.91381 9.60158C2.62325 8.67802 2.58957 7.69278 2.81639 6.75153C3.04322 5.81029 3.52198 4.94854 4.20134 4.25871C4.8807 3.56889 5.73503 3.077 6.67269 2.83581C9.27203 2.16914 11.9627 3.50714 12.956 6.00048",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.3343 2.66687V6.0002H10.001",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerReload);
export default __webpack_public_path__ + "static/media/tabler_reload.ef65e667165be4e69c49d858d94466cb.svg";
export { ForwardRef as ReactComponent };